export enum TxType {
  UPLOAD = 1,
  BUSINESS_REPORT = 2,
  SNAPSHOT = 4,
  CONTRACT_FAMILY_GROUPING = 5,
}
export interface TransactionProgress {
  fse_id: string;
  fse_type: "file" | "folder";
  fse_name: string;
  progress: number;
}
export interface Transaction {
  tx_id: string;
  owner_id: string;
  tx_type: TxType;
  created_at: string;
  fse_id: string;
  fse_type: "file" | "folder";
  fse_name: string;
  progress: number;
  file_progresses: TransactionProgress[];
}
